import { ProductLifecycleStage } from 'src/shared/types/product';

function getLastActiveStageIndex(productStages: ProductLifecycleStage[]) {
  const index = productStages.findIndex((stage) => stage.status !== 'done');

  if (index < 0) {
    return productStages.length - 1;
  }

  return index;
}

export default getLastActiveStageIndex;
